import React from 'react';
import PropTypes from 'prop-types'
import { isDisabled } from '../../utils/controls'
import ClearIcon from '../../components/icons/ClearIcon';

class RitSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultSelectText: "",
      showOptionList: false,
      optionsList: [],
      searchVal: ''
    };
  }

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      defaultSelectText: (this.props.value && this.props.value.displayName) || this.props.defaultText,
      optionsList: this.props.optionsList
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if(JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value) || 
      this.props.defaultText !== prevProps.defaultText || this.props.optionsList.length !== prevProps.optionsList.length) 
    {
      this.setState({
        defaultSelectText: this.props.value.displayName || this.props.defaultText,
        optionsList: this.props.optionsList
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    const classNames = [
      "b-rit-select__list", 
      "b-rit-select__item", 
      "b-rit-select__search-item",
      "b-rit-select__input", 
      "b-rit-select__input-clear", 
    ];
    if (!classNames.some(className => e.target.classList.contains(className))) {
      this.setState({
        showOptionList: false
      });
    }
  };

  handleListDisplay = () => {
    this.setState((prevState) => {
      return {
        showOptionList: !prevState.showOptionList
      };
    });
  };

  handleOptionClick = (index) => {
    const selectedOption = this.state.optionsList[index];
    this.setState({
      defaultSelectText: selectedOption.name,
      showOptionList: false
    });
    if (this.props.onChange) {
      this.props.onChange(selectedOption.value)
    }
  };

  handleSearch = (e) => {
    const val = e.target.value;
    const { optionsList } = this.props;
    let options = [];
    if(val.trim()){
      options = optionsList.filter(o => o.name.toLowerCase().indexOf(val.toLowerCase()) !== -1)
    } else {
      options = optionsList
    }
    this.setState({
      searchVal: e.target.value,
      optionsList: options,
    })
  }

  onClearSearch = () => this.setState({ searchVal: '', optionsList: this.props.optionsList })

  render() {
    const { disabledOptions, withSearch } = this.props;
    const { showOptionList, defaultSelectText, optionsList, searchVal } = this.state;
    return (
      <div className="b-rit-select">
        <div
          className={
            showOptionList
              ? "b-rit-select__selection selection--active"
              : "b-rit-select__selection"
          }
          onClick={this.handleListDisplay}
        >
          {defaultSelectText}
        </div>
        {showOptionList && (
          <ul className="b-rit-select__list">
            {withSearch && 
              <li className="b-rit-select__search-item">
                <input 
                  type="search" 
                  className="b-rit-select__input" 
                  onChange={this.handleSearch} 
                  value={this.state.searchVal} 
                  placeholder="Поиск" />
                {searchVal && 
                  <ClearIcon className="b-rit-select__input-clear" onClick={this.onClearSearch}/>
                }
              </li>
            }
            <li className="b-rit-select__item b-rit-select__item_default-text">
              {defaultSelectText}
              <div className="b-rit-select__devider" />
            </li>
            {optionsList.map((option, index) => {
              return (
                <li
                  className={!isDisabled(disabledOptions, option.value) ? "b-rit-select__item" : "b-rit-select__item-disabled"}
                  data-name={option.name}
                  data-value={option.value}
                  key={option.name}
                  onClick={() => { !isDisabled(disabledOptions, option.value) ? this.handleOptionClick(index) : false; } }
                >
                  {option.name}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

RitSelect.propTypes = {
  defaultText: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  optionsList: PropTypes.array.isRequired,
  withSearch: PropTypes.bool
}

export default RitSelect;
